import { render, staticRenderFns } from "./TemplateActions.vue?vue&type=template&id=e9ffb82c&scoped=true&"
import script from "./TemplateActions.vue?vue&type=script&lang=js&"
export * from "./TemplateActions.vue?vue&type=script&lang=js&"
import style0 from "./TemplateActions.vue?vue&type=style&index=0&id=e9ffb82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ffb82c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VRow})
